import React, { Component, ErrorInfo, PropsWithChildren } from "react";

import { logToSentry } from "../design-system/GenericError";
import ErrorPage from "./ErrorPage";

type ErrorReportingProps = PropsWithChildren<unknown>;

export default class ErrorReporting extends Component<ErrorReportingProps, { error: Error | null }> {
  constructor(props: ErrorReportingProps) {
    super(props);
    this.state = { error: null };
  }

  // This isn't available yet with hooks, so a class component it is.
  componentDidCatch(error: Error, { componentStack }: ErrorInfo) {
    this.setState({ error });
    logToSentry(error, { contexts: { react: { componentStack } } });
  }

  render() {
    if (this.state.error) {
      return <ErrorPage error={this.state.error} />;
    }

    return this.props.children;
  }
}
